import React from "react";
import PropTypes from "prop-types";
import { makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
   numDisplayedText: {
		color: theme.palette.grey.main
	}
}));

export default function NumberDisplayedText({totalCount, type}) {
	if(totalCount > 0)
	{
		const classes = useStyles();
		const typeDisplay = totalCount === 1 ? type : type + "s";
		return (
			<Typography variant="body1" className={classes.numDisplayedText}>
					Showing <b>{totalCount}</b> {typeDisplay}
			</Typography>
		);
	}
	else
	{
		return null;
	}
}

NumberDisplayedText.propTypes = {
	shownFolderCount: PropTypes.number,
	totalFolderCount: PropTypes.number
};
